<template>
  <div class="food-order-page">
    <div class="top-gradient"></div>

    <div class="page-header">
      <div class="back-btn" @click="goBack">
        <van-icon size="1.2rem" name="arrow-left" color="#fff" />
      </div>
      <span class="page-title">{{ pageTitle }}</span>
      <div class="header-placeholder"></div>
    </div>

    <div class="page-content">
      <div v-if="brandList.length > 0" class="food-list">
        <div
          class="food-item"
          v-for="(item, index) in brandList"
          :key="item.id || index"
          @click="goToH5(item)"
        >
          <div class="food-icon-wrapper">
            <van-image fit="contain" :src="item.icon" class="food-icon" lazy-load />
          </div>
          <div class="food-info">
            <div class="food-name">{{ item.name }}</div>
            <div v-if="item.subtitle" class="food-desc">{{ item.subtitle }}</div>
          </div>
          <div class="food-action">
            <span class="action-btn">去购买</span>
          </div>
        </div>
      </div>

      <div v-else class="empty-state">
        <div class="empty-icon">{{ emptyIcon }}</div>
        <div class="empty-text">暂无品牌</div>
        <div class="empty-tip">敬请期待...</div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 品牌聚合页通用壳：列表数据来自 sessionStorage（一级分类 children 缓存）。
 * FoodBrandList / TaofukeBrandList 等路由页仅传入 storageKey 与默认标题。
 */
export default {
  name: 'BrandAggregatePage',
  props: {
    storageKey: {
      type: String,
      required: true,
    },
    defaultTitle: {
      type: String,
      default: '品牌列表',
    },
    emptyIcon: {
      type: String,
      default: '🛍️',
    },
  },
  data() {
    return {
      pageTitle: this.defaultTitle,
      brandList: [],
    };
  },
  mounted() {
    this.initView();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    initView() {
      if (this.$route.query.title) {
        this.pageTitle = this.$route.query.title;
      } else {
        this.pageTitle = this.defaultTitle;
      }
      const raw = sessionStorage.getItem(this.storageKey);
      if (!raw) {
        this.brandList = [];
        return;
      }
      try {
        this.brandList = JSON.parse(raw) || [];
      } catch (e) {
        this.brandList = [];
      }
    },
    goToH5(item) {
      if (!item.jumpPageFlag) {
        this.$Toast('暂无跳转链接');
        return;
      }
      this.$api.getEntrance(item.jumpPageFlag).then((res) => {
        if (res.code === 0) {
          window.location.href = res.data;
        } else {
          this.$Toast.fail(res.msg);
        }
      }).catch(() => {
        this.$Toast.fail('跳转失败');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.food-order-page {
  min-height: 100vh;
  background: #f5f5f5;
  position: relative;
}

.top-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 12rem;
  background: linear-gradient(180deg, #ff6b4a 0%, #ff8a65 50%, #ffb088 100%);
  border-radius: 0 0 2rem 2rem;
  z-index: 0;
}

.page-header {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.back-btn {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(10px);
}

.page-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
}

.header-placeholder {
  width: 2rem;
}

.page-content {
  position: relative;
  z-index: 5;
  padding: 0.5rem 1rem 2rem;
}

.food-list {
  background: #fff;
  border-radius: 1rem;
  padding: 0.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.food-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-radius: 0.8rem;
  transition: all 0.2s ease;

  &:not(:last-child) {
    border-bottom: 1px solid #f5f5f5;
  }

  &:active {
    background: #fafafa;
    transform: scale(0.99);
  }
}

.food-icon-wrapper {
  width: 4rem;
  height: 4rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.food-icon {
  width: 100%;
  height: 100%;
}

.food-info {
  flex: 1;
  margin-left: 1rem;
  overflow: hidden;
}

.food-name {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.4rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.food-desc {
  font-size: 0.8rem;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.food-action {
  flex-shrink: 0;
  margin-left: 0.8rem;
}

.action-btn {
  display: inline-block;
  padding: 0.5rem 1.2rem;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  border-radius: 1.5rem;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 500;
  box-shadow: 0 3px 10px rgba(255, 107, 74, 0.35);
  transition: all 0.2s ease;

  &:active {
    transform: scale(0.95);
    box-shadow: 0 2px 6px rgba(255, 107, 74, 0.4);
  }
}

.empty-state {
  background: #fff;
  border-radius: 1rem;
  padding: 4rem 2rem;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.empty-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
}

.empty-text {
  font-size: 1.1rem;
  font-weight: 500;
  color: #666;
  margin-bottom: 0.5rem;
}

.empty-tip {
  font-size: 0.85rem;
  color: #999;
}
</style>
